import { useEffect, useState } from 'react';

const WHATSAPP = 'https://wa.me/917306725502';
const EMAIL = 'mailto:info@globesynctravel.com';
const INSTAGRAM =
  'https://www.instagram.com/globesync_travel?stkn=YnhxZGZtMGUxZHox';
const FACEBOOK = 'https://www.facebook.com/share/1LSHkL3wre/';
const LOGO =
  'https://public.readdy.ai/ai/img_res/92fe985b-bf86-46bc-98fa-34f8209cf877.png';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]'
          : 'bg-background-50/90 backdrop-blur-sm'
      }`}
    >
      <div className="mx-auto flex h-32 max-w-7xl items-center justify-between px-4 md:h-40 md:px-6">
        {/* Brand logo */}
        <a href="#top" className="flex shrink-0 items-center" aria-label="GlobeSync Travel home">
          <img
            src={LOGO}
            alt="GlobeSync Travel Agency Logo Ernakulam"
            title="GlobeSync Travel — Syncing You with the World"
            className="h-28 w-auto max-w-[55vw] object-contain [filter:drop-shadow(0_2px_6px_rgba(15,23,42,0.22))] md:h-[144px] md:max-w-none"
          />
        </a>

        {/* Center nav */}
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          <a href="#services" className="gs-link text-sm font-semibold text-foreground-700">
            Services
          </a>
          <a href="#why" className="gs-link text-sm font-semibold text-foreground-700">
            Why GlobeSync
          </a>
          <a href="#contact" className="gs-link text-sm font-semibold text-foreground-700">
            Contact
          </a>
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-2 sm:gap-2.5">
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GlobeSync Travel on Instagram"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-primary-600 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <i className="ri-instagram-line text-base" />
          </a>
          <a
            href={FACEBOOK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GlobeSync Travel on Facebook"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-primary-600 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <i className="ri-facebook-fill text-base" />
          </a>
          <a
            href={EMAIL}
            aria-label="Email GlobeSync Travel"
            className="hidden h-9 w-9 items-center justify-center rounded-full border border-background-200 text-primary-600 transition-colors hover:border-primary-300 hover:bg-primary-50 sm:flex"
          >
            <i className="ri-mail-line text-base" />
          </a>
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 md:inline-flex"
          >
            <i className="ri-whatsapp-line text-base" />
            Chat Now
          </a>

          {/* Mobile hamburger */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-900 md:hidden"
          >
            <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="Mobile">
            {[
              ['#services', 'Services'],
              ['#why', 'Why GlobeSync'],
              ['#contact', 'Contact'],
            ].map(([href, label]) => (
              <a
                key={href}
                href={href}
                onClick={() => setMenuOpen(false)}
                className="rounded-lg px-3 py-2.5 text-base font-medium text-foreground-800 hover:bg-background-100"
              >
                {label}
              </a>
            ))}
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-whatsapp-line text-base" />
              Chat on WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}